import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
  LeftSection,
  ComposerButton,
  Airplane,
  Input,
  Label
} from '../Custom/MessageComposer';

const LoadingComposer = () => {
  const { t } = useTranslation('full_page');

  return (
    <Container>
      <LeftSection htmlFor="loading-composer">
        <Label htmlFor="loading-composer">{t('loading_composer_label')}</Label>
        <Input id="loading-composer" disabled />
      </LeftSection>
      <ComposerButton aria-label={t('send_button_label')} disabled>
        <Airplane />
      </ComposerButton>
    </Container>
  );
};

export default LoadingComposer;
